'use client';

import {createContext} from 'react';

// The site is dark-mode only. The context shape is kept so existing
// consumers (theme-dependent images, etc.) keep working unchanged.
export const ThemeContext = createContext({
  theme: 'dark'
});

export function ThemeProvider({children}) {
  const provider = {
    theme: 'dark',
    themeChange: () => {}
  };

  return (
    <ThemeContext.Provider value={provider}>{children}</ThemeContext.Provider>
  );
}
